exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".confirm-dialog {\n  max-width: 700px;\n  min-width: 500px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /dist/src/app/notify/confirm/confirm.component.scss
// module id = ../../../../../src/app/notify/confirm/confirm.component.scss
// module chunks = main